package dev.lingvo.site.ds

/** Strict RGB color validation; colors are user content rather than translated strings. */
object LColorFieldModel {
    private val hex = Regex("^#[0-9a-fA-F]{6}$")

    /** Returns canonical #RRGGBB only for a complete six-digit RGB color. */
    fun commit(raw: String): String? = raw.takeIf(hex::matches)?.uppercase()

    /** Keeps valid swatches in their supplied order, collapsing case-insensitive duplicates. */
    fun swatches(values: List<String>): List<String> = values.mapNotNull(::commit).distinct()
}
